import React from 'react';
import cn from 'classnames';

import Label from 'shared/ui/Label/Label';
import {isTranslate} from 'shared/lib/lang';

import styles from  './LabelMenu.module.scss';

const LabelMenu: React.FC = () => {
    return (
        <Label
            text="NEW"
            classname={cn(
                styles.menu,
                styles[isTranslate() ? 'enBackground' : 'ruBackground'],
            )}
        />
    );
};

export default LabelMenu;